(function () {
  'use strict';

  function updateWishlistCount() {
    const button = document.querySelector('.js-header-wishlist');
    if (!button) return;
    const badge = button.querySelector('.ui-icon-button__count');
    if (!badge) return;
    try {
      const stored = JSON.parse(window.localStorage.getItem('userWishlist') || '[]');
      // The existing wishlist stores an array of Shopify product IDs.
      if (!Array.isArray(stored)) throw new Error('Wishlist must contain product IDs');
      badge.textContent = String(stored.length);
      badge.hidden = stored.length === 0;
      button.setAttribute('aria-label', button.dataset.wishlistLabel + ' (' + stored.length + ')');
    } catch (error) {
      badge.hidden = true;
      button.setAttribute('aria-label', button.dataset.wishlistLabel);
      console.warn('Could not read the wishlist count', error);
    }
  }

  window.addEventListener('wishlist:changed', updateWishlistCount);
  window.addEventListener('storage', function (event) {
    if (event.key === 'userWishlist' || event.key === null) updateWishlistCount();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistCount);
  } else {
    updateWishlistCount();
  }
})();
